import React, { useState, useEffect } from "react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem("foyevoo_cookie")) setShow(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  const accept = (v) => {
    localStorage.setItem("foyevoo_cookie", v);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] bg-[#1e3a52] text-[#f4f0e6] shadow-2xl">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 flex flex-col md:flex-row items-center gap-4 justify-between">
        <p className="text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
          We use cookies to improve your experience, just like olive oil makes everything better. We don't share your info with anyone. Accept for a smooth experience!{" "}
          <a href="/privacy" className="underline">Privacy Policy</a>
        </p>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button onClick={() => accept("settings")} className="text-sm px-4 py-2 hover:underline">Settings</button>
          <button onClick={() => accept("declined")} className="text-sm px-4 py-2 border border-[#f4f0e6]/40 hover:bg-[#f4f0e6]/10 rounded-sm">Decline All</button>
          <button onClick={() => accept("accepted")} className="text-sm px-5 py-2 bg-[#f4f0e6] text-[#1e3a52] font-medium rounded-sm hover:bg-white">Accept</button>
        </div>
      </div>
    </div>
  );
}
